import * as React from "react";

import { createStyles, withStyles, WithStyles } from "@material-ui/core";
import classnames from "classnames";

import { RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
            color: "unset",
            flexShrink: 0,
            zIndex: 2,
            backgroundColor: "transparent",
        },
        shadow: {
            boxShadow:
                "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14)",
            paddingBottom: 4,
            overflow: "hidden",
            marginTop: -4,
        },
    });

interface Props extends WithStyles<typeof styles> {
    children?: React.ReactNode;
    className?: string;
}

export const PageSectionHeader = withStyles(styles, {
    name: "PageSectionHeader",
})((props: Props) => {
    const { classes, className: classNameProp, children } = props;

    const rootClasses = classnames(
        {
            [classes.root]: true,
        },
        classNameProp
    );

    return (
        <div className={rootClasses}>
            {children}
            <div className={classes.shadow} />
        </div>
    );
});
